import { render, staticRenderFns } from "./CurrencyBreakdown.vue?vue&type=template&id=11b74aac&scoped=true&"
import script from "./CurrencyBreakdown.vue?vue&type=script&lang=js&"
export * from "./CurrencyBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyBreakdown.vue?vue&type=style&index=0&id=11b74aac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b74aac",
  null
  
)

export default component.exports